import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList, withCtx as _withCtx, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createSlots as _createSlots } from "vue"


import store from '../store'
import { defineComponent, defineAsyncComponent, defineProps } from 'vue'
import { isEmptyArray, isTrue, isEmptyString } from '../utils'
import EditColumnTable from './EditColumnTable.vue'
import PageDescription from './PageDescription.vue'

const __default__ = defineComponent({
  name: 'ViewRender',
  components: {
    EditColumnTable,
    PageDescription,
    PageEditor: defineAsyncComponent(() => import('./PageEditor.vue'))
  }
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  item: {
    type: Object,
    required: true
  },
  isEditPageMode: {
    type: Boolean,
    required: false,
    default: false
  },
  tabName: {
    type: String,
    required: true
  }
},
  setup(__props) {

// import PageEditor from './PageEditor.vue'
const props = __props

const isSlot = () => {
  // eslint-disable-next-line
  const currentItem = props.item
  if (isEmptyArray(currentItem.children)) {
    return false
  }
  // eslint-disable-next-line
  const subItem = currentItem.children[0]
  if (subItem.tag !== 'template' || isEmptyString(subItem.slot_name)) {
    return false
  }
  return true
}
const getSlot = () => {
  // eslint-disable-next-line
  const currentItem = props.item
  // eslint-disable-next-line
  const subItem = currentItem.children[0]
  return subItem.slot_name
}

return (_ctx: any,_cache: any) => {
  const _component_PageEditor = _resolveComponent("PageEditor")!
  const _component_ViewRender = _resolveComponent("ViewRender", true)!

  return (__props.isEditPageMode && _unref(isTrue)(__props.item.is_container))
    ? (_openBlock(), _createBlock(_component_PageEditor, {
        key: 0,
        tabName: __props.tabName,
        item: __props.item
      }, null, 8, ["tabName", "item"]))
    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
        (!_unref(isEmptyString)(__props.item.tag) && __props.item.tag === 'el-col')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(_toDisplayString(__props.item), 1)
            ], 64))
          : _createCommentVNode("", true),
        (!_unref(isEmptyString)(__props.item.tag))
          ? (_openBlock(), _createBlock(_resolveDynamicComponent(__props.item.tag), _mergeProps({ key: 1 }, __props.item, {
              isEditPageMode: __props.isEditPageMode,
              modelValue: _unref(store).state.modelValues[__props.tabName][__props.item.id],
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(store).state.modelValues[__props.tabName][__props.item.id]) = $event))
            }), _createSlots({
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(__props.item.title) + " ", 1),
                (isSlot())
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(__props.item.children, (subItem, index) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: subItem.tag
                      }, [
                        (index>0)
                          ? (_openBlock(), _createBlock(_component_ViewRender, {
                              tabName: __props.tabName,
                              item: subItem,
                              key: subItem.tag
                            }, null, 8, ["tabName", "item"]))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128))
                  : _createCommentVNode("", true),
                (!isSlot())
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(__props.item.children, (subItem) => {
                      return (_openBlock(), _createBlock(_component_ViewRender, {
                        tabName: __props.tabName,
                        isEditPageMode: __props.isEditPageMode,
                        item: subItem,
                        key: subItem.tag
                      }, null, 8, ["tabName", "isEditPageMode", "item"]))
                    }), 128))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, [
              (isSlot())
                ? {
                    name: getSlot,
                    fn: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.item.children[0].children, (subItem) => {
                        return (_openBlock(), _createBlock(_component_ViewRender, {
                          tabName: __props.tabName,
                          item: subItem,
                          key: subItem.title
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(subItem), 1)
                          ]),
                          _: 2
                        }, 1032, ["tabName", "item"]))
                      }), 128))
                    ]),
                    key: "0"
                  }
                : undefined
            ]), 1040, ["isEditPageMode", "modelValue"]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createTextVNode(_toDisplayString(__props.item.title), 1)
            ], 64))
      ], 64))
}
}

})